import React from 'react';
import {useDispatch} from 'react-redux';

import {verifyColleague} from '../../actions/colleagues';

import Button from 'src/components/button';

interface Props {
  id: string;
}

const VerifyColleague = ({id}: Props) => {
  const dispatch = useDispatch();

  const handleVerifyColleague = () => {
    dispatch(verifyColleague({id}));
  };

  return (
    <Button
      onClick={handleVerifyColleague}
      outline
      size="small"
      margin={false}
      buttonName="verify colleague"
      testId="verify-colleague-button"
    >
      Verify&nbsp;Colleague
    </Button>
  );
};

export default VerifyColleague;
